import Vue from 'vue';
import Router from "vue-router";
import Home from "./views/Home";
import DataEntryLogin from "./views/DataEntryLogin";
import AlertMessage from "./views/AlertMessage";
import SessionExpiredMessage from "./views/SessionExpiredMessage";


//router.js-routes BEGIN

import tbFrmInterviewConsentForm from "./views/tbFrmInterviewConsentForm";
import tbFrmYourOverallHealth from "./views/tbFrmYourOverallHealth";
import tbFrmQOL from "./views/tbFrmQOL";
import tbFrmPROMISNeuro from "./views/tbFrmPROMISNeuro";
import tbFrmQoLEQ5D5L_EQ5D from "./views/tbFrmQoLEQ5D5L_EQ5D";
import tbFrmIPAQSF from "./views/tbFrmIPAQSF";
import tbFrmChgOfContDtl from "./views/tbFrmChgOfContDtl";
import tbFrmRecentMedicalProblems from "./views/tbFrmRecentMedicalProblems";
import tbFrmHealthSocialCareResourceUse from "./views/tbFrmHealthSocialCareResourceUse";
import tbFrmStudyResults from "./views/tbFrmStudyResults";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,routes: [
    //Fixed routes
    {path: "/",name: "home",component: Home,},
    {path: "/data-entry-login",name: "data-entry-login",component: DataEntryLogin, meta: {checkAuthStatus: true}},
    {path: "/alert-message",name: "alert-message",component: AlertMessage,},
    {path: "/session-expired-message",name: "session-expired-message",component: SessionExpiredMessage,},
    //Trial-specific routes
    {
      path: "/interview-consent-form", name: "interview-consent-form",
      component: tbFrmInterviewConsentForm,
      meta: {
        dataTableID: 'tbFrmInterviewConsentForm',
        checkAuthStatus: true,
        eventID: 100
      },
    },
    {
      path: "/overall-health", name: "overall-health",
      component: tbFrmYourOverallHealth,
      meta: {
        dataTableID: 'tbFrmYourOverallHealth',
        checkAuthStatus: true
      },
    },
    {
      path: "/qol", name: "qol",
      component: tbFrmQOL,
      meta: {
        dataTableID: 'tbFrmQOL',
        checkAuthStatus: true
      },
    },
    {
      path: "/promis", name: "promis",
      component: tbFrmPROMISNeuro,
      meta: {
        dataTableID: 'tbFrmPROMISNeuro',
        checkAuthStatus: true
      },
    },
    {
      path: "/general-health-eq5d", name: "general-health-eq5d",
      component: tbFrmQoLEQ5D5L_EQ5D,
      meta: {
        dataTableID: 'tbFrmQoLEQ5D5L_EQ5D',
        checkAuthStatus: true
      },
    },
    {
      path: "/ipaqsf", name: "ipaqsf",
      component: tbFrmIPAQSF,
      meta: {
        dataTableID: 'tbFrmIPAQSF',
        checkAuthStatus: true
      },
    },
    {
      path: "/change-of-contact", name: "change-of-contact",
      component: tbFrmChgOfContDtl,
      meta: {
        dataTableID: 'tbFrmChgOfContDtl',
        checkAuthStatus: true
      },
    },
    {
      path: "/medical-problems", name: "medical-problems",
      component: tbFrmRecentMedicalProblems,
      meta: {
        dataTableID: 'tbFrmRecentMedicalProblems',
        checkAuthStatus: true
      },
    },
    {
      path: "/resource-use", name: "resource-use",
      component: tbFrmHealthSocialCareResourceUse,
      meta: {
        dataTableID: 'tbFrmHealthSocialCareResourceUse',
        checkAuthStatus: true
      },
    },
    {
      path: "/study-results", name: "study-results",
      component: tbFrmStudyResults,
      meta: {
        dataTableID: 'tbFrmStudyResults',
        checkAuthStatus: true,
        eventID: 90
      },
    },
  ],
});

//router.js-routes END   
